module.exports = __webpack_public_path__ + "img/android.031ca689.svg";